import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import { StateService } from 'common/services/stateService'
import { rootSlice } from 'common/store/slices/rootSlice'

import { leaseSlice } from 'features/Booking'
import { cartSlice } from 'features/Cart'
import { optionSlice } from 'features/Option'
import { promotionSlice } from 'features/Home/Promotion/state/promotionsSlice'
import { bookSlice } from 'features/Home/Book/state/slice/bookSlice'
import { jitsiTelehealthSlice } from 'features/JitsiTelehealth/state/jitsiTelehealth.slice'
import { procedureSlice } from 'features/Procedure/state/procedure.slice'

const rootReducer = combineReducers({
  rootReducer: rootSlice.reducer,

  cartReducer: cartSlice.reducer,
  leaseReducer: leaseSlice.reducer,
  optionReducer: optionSlice.reducer,
  bookReducer: bookSlice.reducer,
  promotionReducer: promotionSlice.reducer,
  procedureReducer: procedureSlice.reducer,
  jitsiTelehealthReducer: jitsiTelehealthSlice.reducer,
  ...StateService.getAppApiReducerList(),
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(StateService.getAppMiddlewareList()),
})

setupListeners(store.dispatch)
